import React, { useState, useRef } from "react";
import MDTypography from "components/MDTypography";
import LoadingButton from "components/LoadingButton";
import { Card, Grid, TextField } from "@mui/material";
import PropTypes from "prop-types";

const ReportIssueForm = (props) => {
  const { onSubmitHandler } = props;

  const [images, setImages] = useState([]);
  const imagesRef = useRef();

  const [subject, setSubject] = useState("");
  const [subjectHasError, setSubjectHasError] = useState(false);
  const [subjectErrorMessage, setSubjectErrorMessage] = useState("");
  const onSubjectChangeHandler = (event) => {
    const subject1 = event.target.value;
    setSubject(subject1);
    if (subject1.length > 0) {
      setSubjectHasError(false);
      setSubjectErrorMessage("");
    } else {
      setSubjectHasError(true);
      setSubjectErrorMessage("Subject is required");
    }
  };

  const [phone, setPhone] = useState("");
  const [phoneHasError, setPhoneHasError] = useState(false);
  const [phoneErrorMessage, setPhoneErrorMessage] = useState("");
  const onPhoneChangeHandler = (event) => {
    const phone1 = event.target.value;
    setPhone(phone1);
    if (phone1.length === 10) {
      setPhoneHasError(false);
      setPhoneErrorMessage("");
    } else {
      setPhoneHasError(true);
      setPhoneErrorMessage("Phone is required");
    }
  };

  const [message, setMessage] = useState("");
  const [messageHasError, setMessageHasError] = useState(false);
  const [messageErrorMessage, setMessageErrorMessage] = useState("");
  const onMessageChangeHandler = (event) => {
    const message1 = event.target.value;
    setMessage(message1);
    if (message1.length > 0) {
      setMessageHasError(false);
      setMessageErrorMessage("");
    } else {
      setMessageHasError(true);
      setMessageErrorMessage("Message is required");
    }
  };

  // const [loading, setLoading] = useState(false);

  const formSubmitHandler = (e) => {
    e.preventDefault();
    onSubmitHandler(phone, subject, message, images);
  };

  return (
    <form onSubmit={formSubmitHandler} style={{ width: "100%" }}>
      <Card style={{ padding: "30px", background: "#1A73E8" }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MDTypography variant="h5" color="white" fontWeight="medium">
              Report Issue
            </MDTypography>
          </Grid>
          <Grid item xs={12} md={12}>
            <MDTypography variant="h6" color="white">
              Phone<span style={{ color: "#f44" }}>*</span>
            </MDTypography>
            <TextField
              value={phone}
              type="number"
              onChange={onPhoneChangeHandler}
              error={phoneHasError}
              helperText={phoneErrorMessage}
              className="contact-us-label-control"
              style={{ width: "100%", background: "#ffffff", borderRadius: "0.375rem" }}
              label="Phone Number"
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <MDTypography variant="h6" color="white">
              Subject<span style={{ color: "#f44" }}>*</span>
            </MDTypography>
            <TextField
              value={subject}
              onChange={onSubjectChangeHandler}
              error={subjectHasError}
              helperText={subjectErrorMessage}
              className="contact-us-label-control"
              style={{ width: "100%", background: "#ffffff", borderRadius: "0.375rem" }}
              label="Subject"
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <MDTypography variant="h6" color="white">
              Message<span style={{ color: "#f44" }}>*</span>
            </MDTypography>
            <TextField
              value={message}
              onChange={onMessageChangeHandler}
              error={messageHasError}
              helperText={messageErrorMessage}
              className="contact-us-label-control"
              style={{ width: "100%", background: "#ffffff", borderRadius: "0.375rem" }}
              label="Message"
              multiline
              rows={4}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <MDTypography variant="h6" color="white">
              Images
            </MDTypography>
            <TextField
              label="Images"
              type="file"
              inputProps={{ multiple: true }}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              style={{ width: "100%", background: "#ffffff", borderRadius: "0.375rem" }}
              inputRef={imagesRef}
              onChange={(e) => {
                setImages(e.target.files);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <LoadingButton loading={false} variant="contained" color="dark" type="submit">
              Submit
            </LoadingButton>
          </Grid>
        </Grid>
      </Card>
    </form>
  );
};

ReportIssueForm.propTypes = {
  onSubmitHandler: PropTypes.func.isRequired,
};

export default ReportIssueForm;
